import React from 'react'
import { h3, text } from '../typography/index'
import './gift.sass'
import GiftForm from '../gift-form'
import { GiftContent } from './gift-content'
import * as API from '../../service/user'
import analytics from '../../shared/analytics'
import {SANDBOX} from '../../shared/settings'
import Modal from '../modal'
import { content } from '../gift-texts/gift-texts'
import Button from '../common/button'
import GiftContext from '../../context/context'
import { getParamFromUrl } from '../../utils/url'

import Logo from '../../img/brand-new-logo.svg'
import { getLangFromRouter } from '../../utils/getLangFromRouter'
import Loader from '../common/loader'
import { REFERRAL_MODE, PROMO_MODE } from '../../shared/modes'
import { CONTENT_SIGNUP, CONTENT_DONE, CONTENT_LOGIN } from '../../shared/contentStates'
import ExternalLink from '../common/externalLink'
import { getStrapiData } from '../../service/user'

class Gift extends React.Component {
  static contextType = GiftContext
  content = React.createRef()
  state = {
    contentState: null,
    modalError: null,
    isLoading: true,
    contentStrapi: null
  }

  closeModal = () => {
    if (this.state.modalError.link) window.location.replace('https://flyxo.com')
    else this.setState({ modalError: false })
  }

  errorModal = (key, action = 'close') => {
    const actions = {
      flyxo: {
        text: 'Go to FlyXO',
        link: 'https://flyxo.com',
      },
      close: {
        text: 'Try again',
        link: null,
      },
    }

    const modalError = actions[action]
    modalError.message = key.message

    this.setState({ modalError, isLoading: false })
  }
  switchContent = (contentState, wrapper) => {
    this.content.current.classList.add('animation')
    if (wrapper) wrapper.classList.add('animation')
    setTimeout(() => {
      this.setState({ contentState })
      this.content.current.classList.remove('animation')
      if (wrapper) wrapper.classList.remove('animation')
    }, 200)
  }

  async componentDidMount() {
    const code = getParamFromUrl('code')
    const debug = SANDBOX === 'true' && getParamFromUrl('debug');
    if (!code) {
      this.errorModal({ message: 'Sorry, please try to find promo code to use this page' }, 'flyxo')
      analytics.withoutCode()
      this.setState({ isLoading: false })
    } else {
      try {
        const res = debug ? { generatedBy: debug === REFERRAL_MODE } : await API.checkCode(code)
        const mode = res.generatedBy ? REFERRAL_MODE : PROMO_MODE
        const data = await getStrapiData(code)

        this.context.updateState({
          mode,
          code,
          lang: getLangFromRouter(this.props.match),
        })
        this.setState({
          contentState: CONTENT_SIGNUP,
          contentStrapi: data[0] ?? null,
          isLoading: false,
        })
        analytics.codeFound(mode)
      } catch (e) {
        this.errorModal({ message: 'Sorry, we dont have this code' }, 'flyxo')
        analytics.codeNotFound()
        this.setState({ isLoading: false })
      }
    }
  }

  getLegal(mode) {
    if (mode === REFERRAL_MODE) return content.referral.legal()
    if (mode === PROMO_MODE) return content.promo.legal(this.context.formData.lang, this.context.formData.code)
  }

  render() {
    const { contentStrapi, contentState, isLoading } = this.state;
    const { code, mode, lang } = this.context.formData
    const isLegalNeeded =
      contentState === CONTENT_SIGNUP || contentState === CONTENT_LOGIN
    const isLargeContent =
      code && ['WELCOMEGBXOB', 'WELCOMEGNBGXOB'].includes(code.toUpperCase()) ? '--isLarge' : ''
    return (
      <div className="flyxo-landing --common" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
        <div className="full-view" />
        <div className={`content --${mode} ${isLargeContent}`}>
          <div className="content-top">
            <ExternalLink to="https://flyxo.com" className="content-top__brand-logo">
              <img src={Logo} alt="XO logo" />
            </ExternalLink>
          </div>
          {isLoading ? (
            <Loader />
          ) : (
            <div className="content-middle">
              <div className="content-middle__item content-text" ref={this.content}>
                {contentState ? <GiftContent {...this.state} errorModal={this.errorModal} /> : null}
              </div>
              <div className="content-middle__item content-form">
                {contentState && contentState !== CONTENT_DONE ? (
                  <GiftForm content={contentStrapi} switchContent={this.switchContent} errorModal={this.errorModal} />
                ) : null}
              </div>
            </div>
          )}
          {contentStrapi?.disclaimer  && isLegalNeeded && <div className="content-footer" dangerouslySetInnerHTML={{ __html: contentStrapi.disclaimer }} />}
          {!contentStrapi && isLegalNeeded ? <div className="content-footer">{this.getLegal(mode)}</div> : null}
        </div>
        {this.state.modalError ? (
          <Modal small onClose={this.closeModal}>
            <div className="landing-modal">
              <div className="landing-modal__content">
                {h3({}, <span>Activation error</span>)}
                {text({ margin: '30px 0' }, <span>{this.state.modalError.message}</span>)}
                {
                  <Button className="modal__button" onClick={this.closeModal}>
                    {this.state.modalError.text}
                  </Button>
                }
              </div>
            </div>
          </Modal>
        ) : null}
      </div>
    )
  }
}

export default Gift
